import { render, staticRenderFns } from "./edit-product-brands-winners.modal.vue?vue&type=template&id=10b4b85c&scoped=true&"
import script from "./edit-product-brands-winners.modal.vue?vue&type=script&lang=js&"
export * from "./edit-product-brands-winners.modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-product-brands-winners.modal.vue?vue&type=style&index=0&id=10b4b85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4b85c",
  null
  
)

export default component.exports